import React from 'react';
import i18n from 'util/i18n';
import { formConfig } from 'config/forms';
import { getNumberOfYearsString } from 'helpers/text';

import { Summary, DateSummary } from 'components/Summary';
import { SUBSTANCE_USE, SUBSTANCE_USE_THC_PUBLIC_SAFETY } from 'config/formSections/substanceUse';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Comments from 'components/Form/Comments';
import { isPVQForm } from 'helpers/form';
import ThcPublicSafetyUse from './ThcPublicSafetyUse';

const sectionConfig = {
  key: SUBSTANCE_USE_THC_PUBLIC_SAFETY.key,
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_THC_PUBLIC_SAFETY.name,
  storeKey: SUBSTANCE_USE_THC_PUBLIC_SAFETY.storeKey,
};

export class ThcPublicSafetyUses extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateList = this.updateList.bind(this);
    this.updateUsedThc = this.updateUsedThc.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (updateValues) => {
    this.props.onUpdate(this.storeKey, {
      UsedThc: this.props.UsedThc,
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...updateValues,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateUsedThc = (values) => {
    this.update({
      UsedThc: values,
      List: values.value === 'Yes' ? this.props.List : [],
      SummaryComments: values.value === 'Yes' ? this.props.SummaryComments : {}
    });
  };

  updateComments = (values) => {
    this.update({
      Comments: values,
    });
  };

  updateSummaryComments = (values) => {
    this.update({
      SummaryComments: values,
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const range = DateSummary(o.InvolvementDates);
    const description = (o.Description || {}).value;

    return Summary({
      type: i18n.t('substance.pvq.thc.clearance.collection.itemType'),
      index,
      left: description,
      right: range,
      placeholder: i18n.t('substance.pvq.thc.clearance.collection.summary'),
    });
  };

  render() {
    const { formType, errors } = this.props;
    const formTypeConfig = formType && formConfig[formType];
    const years = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS;
    const branchLabelCopy = i18n.t('substance.pvq.thc.heading.thcPublicSafetyUses');

    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const isPvq = isPVQForm(this.props.formType);
    return (
      <div
        className="section-content thc-public-safety-uses"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_THC_PUBLIC_SAFETY.key}
      >
        <h1 className="section-header">{i18n.t('substance.pvq.subsection.drugs.publicsafety')}</h1>
        <Branch
          attribute="UsedThc"
          name="UsedThc"
          label={branchLabelCopy}
          labelSize="h4"
          className="used-thc"
          {...this.props.UsedThc}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateUsedThc}
          scrollIntoView={this.props.scrollIntoView}
        />
        <Show when={this.props.UsedThc.value === 'Yes'}>
          <Accordion
            attribute="List"
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('substance.pvq.thc.publicSafety.collection.description')}
            appendTitle={i18n.t('substance.pvq.thc.publicSafety.collection.appendTitle')}
            appendLabel={i18n.t('substance.pvq.thc.publicSafety.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          >
            <ThcPublicSafetyUse
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

ThcPublicSafetyUses.defaultProps = {
  UsedThc: {},
  List: { items: [], branch: {} },
  onError: (value, arr) => arr,
  section: 'substance',
  subsection: 'thc/publicsafety',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
  formType: '',
};

export default connectSubsection(ThcPublicSafetyUses, sectionConfig);
